module.exports = __webpack_public_path__ + "img/terms_en.96021e8.jpg";